module.exports = "/_next/static/images/c041a69427c10c75dddfc66596d5f6c0-hick@1x.png.webp";